





















































































































































import { Watch, Component, Vue, Inject, Ref } from 'vue-property-decorator'
import { TriggeredAction } from '@/api/model/triggered-action'
import { v4 as uuid } from 'uuid'
import { TriggeredActionAPI } from '@/api/backend-client'

import { namespace } from 'vuex-class'
import { ActionType } from '@/api/types'
import CreateAutoActionPopout from '@/components/virtual-colleague/auto-action/CreateAutoActionSideSheet.vue'
const triggeredActions = namespace('triggeredAction')

@Component({
    components: { CreateAutoActionPopout },
})
export default class CompanySettingsTriggeredAction extends Vue {
    @triggeredActions.State readonly loading!: boolean
    @triggeredActions.State readonly triggeredActions!: TriggeredAction[]
    @triggeredActions.State readonly totalItems!: number
    @triggeredActions.State readonly totalPages!: number
    @triggeredActions.State readonly page!: number
    @triggeredActions.State readonly orderField!: string|null
    @triggeredActions.State readonly orderDirection!: string|null
    @triggeredActions.Action applyCompanyFilter: (payload: { query: string }) => Promise<void>
    @triggeredActions.Action nextPage: () => Promise<void>
    @triggeredActions.Action prevPage: () => Promise<void>
    @triggeredActions.Action applyOrder: ({ field, direction }) => Promise<void>
    @Inject() readonly reloadCompany: () => Promise<void>
    @Ref() autoActionPopout: CreateAutoActionPopout

    created() {
        this.onRouteChange()
    }

    @Watch('$route')
    async onRouteChange(): Promise<void> {
        await this.applyCompanyFilter({
            query: this.$currentCompany.id,
        })
    }

    async reload() {
        await this.applyCompanyFilter({
            query: this.$currentCompany.id,
        })
        this.$forceUpdate()
    }

    async goToTriggeredActionCreate(): Promise<void> {
        this.autoActionPopout.open()
    }

    async goToTriggeredActionDetail(triggeredAction: TriggeredAction): Promise<void> {
        this.autoActionPopout.openWithExisting(triggeredAction)
    }

    generateHeaderClasses(field: string) {
        return {
            'sortable': true,
            'sorted': this.orderField === field,
            'sorted--asc': this.orderField === field && this.orderDirection === 'asc',
            'sorted--desc': this.orderField === field && this.orderDirection === 'desc',
        }
    }

    changeOrder(field: string, direction: string) {
        if (this.orderField === field) {
            direction = this.orderDirection === 'asc' ? 'desc' : 'asc'
        }

        this.applyOrder({
            field,
            direction,
        })
    }

    referralTranslationPath(triggeredAction: TriggeredAction): string {
        if (this.$currentCompany.pipelinesEnabled) {
            return 'company_settings.triggered_actions.rule.referralPipeline'
        } else {
            return 'company_settings.triggered_actions.rule.referralType'
        }
    }

    referralPipelineLabel(triggeredAction: TriggeredAction): string {
        if (!triggeredAction.referralPipeline) {
            return '-'
        }

        return triggeredAction.referralPipeline.name
    }

    referralTypeLabel(triggeredAction: TriggeredAction): string {
        if (!triggeredAction.referralType) {
            return '-'
        }

        return this.$t(`referral.type.${triggeredAction.referralType}`).toString()
    }

    referralOriginLabel(triggeredAction: TriggeredAction): string {
        if (!triggeredAction.referralOrigin) {
            return ''
        }

        return this.$t(`company_settings.triggered_actions.rule.referralOrigin.${triggeredAction.referralOrigin}`).toString()
    }

    triggerTypeTranslationPath(triggeredAction: TriggeredAction): string {
        if (this.$currentCompany.pipelinesEnabled) {
            return 'company_settings.triggered_actions.rule.referralPipeline'
        } else {
            return 'company_settings.triggered_actions.rule.referralType'
        }
    }

    phaseLabel(triggeredAction: TriggeredAction): string {
        const pipeline = triggeredAction.referralPipeline
        if (!pipeline) {
            return '-'
        }

        const phase = pipeline.getPhase(triggeredAction.changedFieldValue)
        if (!phase) {
            return triggeredAction.changedFieldValue
        }

        return phase.name
    }

    statusLabel(triggeredAction: TriggeredAction): string {
        if (this.$currentCompany.pipelinesEnabled) {
            return this.$t(`referral.phaseModelStatus.${triggeredAction.changedFieldValue}`).toString()
        } else {
            return this.$t(`referral.status.${triggeredAction.changedFieldValue}`).toString()
        }
    }

    emptyFieldLabel(triggeredAction: TriggeredAction): string {
        return this.$t(`forms.triggered_action_form.empty_field_options.${triggeredAction.emptyField}`).toString()
    }

    actionTypeLabel(triggeredAction: TriggeredAction): string {
        return this.$t(`action.type.${triggeredAction.actionType}`).toString()
    }

    actionAssignToTypeLabel(triggeredAction: TriggeredAction): string {
        return this.$t(`forms.triggered_action_form.action-assigned-to-type-options.${triggeredAction.actionAssignToType}`).toString()
    }

    async deleteTriggeredAction(triggeredAction) {
        if (confirm(this.$t('company_settings.triggered_actions.delete_confirm').toString())) {
            await TriggeredActionAPI.delete(triggeredAction.id)
            await this.reloadCompany()
        }
    }

    isAddToPipeline(triggeredAction: TriggeredAction): boolean {
        return triggeredAction.actionType === ActionType.ADD_TO_PIPELINE
    }
}
